import PropTypes from 'prop-types';

import StockReceiptCommandBar from './StockReceiptCommandBar';
import StockReceiptDetailSection from './StockReceiptDetailSection';
import StockReceiptMainInfoCard from './StockReceiptMainInfoCard';

const StockReceiptBlock = ({
  detail,
  defaultOpen = true,
  onRefetch,
  showActions = false,
}) => (
  <div className="receipt-card-elevate">
    <div className="receipt-card-surface">
      <StockReceiptMainInfoCard
        detail={detail}
        embedded
        actions={
          showActions ? (
            <StockReceiptCommandBar
              key={`${detail.id}-${detail.record?.updatedAt ?? ''}`}
              detail={detail}
              onRefetch={onRefetch}
            />
          ) : null
        }
      />
      <StockReceiptDetailSection detail={detail} embedded defaultOpen={defaultOpen} />
    </div>
  </div>
);

StockReceiptBlock.propTypes = {
  detail: PropTypes.shape({
    id: PropTypes.string,
    receiptNo: PropTypes.string,
    status: PropTypes.string,
    record: PropTypes.shape({
      updatedAt: PropTypes.string,
    }),
    warehouse: PropTypes.shape({
      displayName: PropTypes.string,
    }),
    lines: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  defaultOpen: PropTypes.bool,
  onRefetch: PropTypes.func,
  showActions: PropTypes.bool,
};

export default StockReceiptBlock;
